export default __webpack_public_path__ + "static/media/logo.76eb4b75.png";